
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import {
	ProfileSection,
	ProfileSectionError,
	profileFieldText,
} from "../common/ProfileSection";

export default function IntroSection({ profileId, isOwner }) {
	const [profile, setProfile] = useState({});
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		fetchProfile();
	}, []);

	function fetchProfile() {
		api.profileDetail({
			token: LoginHelper.getToken(),
			profile_id: profileId,
		})
			.then((result) => {
				setProfile(result);
			})
			.catch((err) => {
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	const intro = profileFieldText(profile.intro);

	return (
		<ProfileSection title="معرفی">
			{intro ? (
				<p className="font-Vazir-400 text-[15px] text-midGray leading-7 text-center whitespace-pre-wrap" dir="auto">
					{intro}
				</p>
			) : (
				<p className="font-Vazir-400 text-[14px] text-grayText text-center leading-7">
					{isOwner ? (
						<>
							هنوز متن معرفی ثبت نشده است.{" "}
							<Link to="/profile_edit/" className="text-darkBlue font-Vazir-600 hover:underline">
								افزودن معرفی
							</Link>
						</>
					) : (
						"معرفی ثبت نشده است."
					)}
				</p>
			)}
			<ProfileSectionError message={errorMessage} />
		</ProfileSection>
	);
}
